import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

import { PayRocPageRoutingModule } from './payroc-routing.module';

import { PayRocPage } from './payroc.page';
import { MasterHeaderModule } from '../../../master-header/master-header.module';
import { MasterFooterModule } from '../../../master-footer/master-footer.module';
import { CustomInputModule } from '../../../common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    PayRocPageRoutingModule,
    MasterHeaderModule,
    MasterFooterModule,
    CustomInputModule,
    TranslateModule
  ],
  declarations: [PayRocPage],
})
export class PayRocPageModule {}
